(function () {
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  // Product gallery thumbnails
  document.querySelectorAll('.gallery').forEach(function (g) {
    var main = g.querySelector('[data-main]');
    g.querySelectorAll('.thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.dataset.src;
        g.querySelectorAll('.thumbs button').forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  });

  // Cart waitlist: step 1 = intent to check out, step 2 = email
  var wl = document.querySelector('.js-wl');
  var cartData = wl ? {
    value: parseFloat(wl.dataset.value) || 0,
    currency: wl.dataset.currency || 'USD',
    content_ids: (wl.dataset.ids || '').split(',').filter(Boolean),
    num_items: parseInt(wl.dataset.qty, 10) || 0
  } : null;
  if (wl) {
    var open = wl.querySelector('[data-wl-open]');
    if (wl.querySelector('[data-waitlist-ok]')) wl.classList.add('open');
    if (open) open.addEventListener('click', function () {
      wl.classList.add('open');
      publish('waitlist_initiate_checkout', cartData);
      var input = wl.querySelector('input[type=email]');
      if (input) input.focus();
    });
  }

  // Any waitlist email form
  document.querySelectorAll('form.js-waitlist').forEach(function (f) {
    f.addEventListener('submit', function () {
      var d = cartData || { value: 0, currency: 'USD', content_ids: [], num_items: 0 };
      var tags = f.querySelector('[name="contact[tags]"]');
      publish('waitlist_lead', Object.assign({ source: tags ? tags.value.split(',')[1] || '' : '' }, d));
    });
  });
})();

// Scroll reveal (content stays visible without JS: .reveal is only hidden under html.js)
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (e) { io.observe(e); });
})();
